import ObjectAddEditForm from "./ObjectAddEditForm";
import {
  RangeSlider,
  Text,
  Select,
  NumberInput,
  Center,
  Flex,
  ColorPicker,
  Button,
  ColorInput,
  Input,
} from "@mantine/core";
import { getDevice } from "pages/Admin/Device/apis/adminDeviceApis";

import React, { useState, useEffect } from "react";

function ThresholdForm(props) {
  const { libraryList, thresholdOnSubmit, defaultValue } = props;

  const ThresholdRange = (props) => {
    const { field, name } = props;

    const minDefaultValue =
      defaultValue?.imgye_st === undefined ||
      defaultValue?.imgye_st === "" ||
      isNaN(Number(defaultValue?.imgye_st))
        ? ""
        : Number(defaultValue?.imgye_st);

    const maxDefaultValue =
      defaultValue?.imgye_ed === undefined ||
      defaultValue?.imgye_ed === "" ||
      isNaN(Number(defaultValue?.imgye_ed))
        ? ""
        : Number(defaultValue?.imgye_ed);

    const [minValue, setMinValue] = useState(minDefaultValue);
    const [maxValue, setMaxValue] = useState(maxDefaultValue);

    const updateValue = (values) => {
      setMinValue(values[0]);
      setMaxValue(values[1]);
      field.onChange(values);
    };

    return (
      <>
        <Text size="sm">{name}</Text>
        <Flex gap={5}>
          <NumberInput
            id="minValue"
            value={minValue}
            onChange={(event) => updateValue([event, maxValue])}
          />
          ~
          <NumberInput
            id="maxValue"
            value={maxValue}
            onChange={(event) => updateValue([minValue, event])}
          />
        </Flex>
      </>
    );
  };

  const SelectLibrary = (props) => {
    const { field, name } = props;
    return (
      <Select label={name} data={libraryList} value={field.value} {...field} />
    );
  };

  const SelectFontSize = (props) => {
    const { field, name, defaultValue, disabled } = props;
    return (
      <NumberInput
        label={name}
        value={parseInt(field.value)}
        defaultValue={defaultValue}
        disabled={disabled}
        formatter={(value) => `${value} px`}
        max={100}
        {...field}
      />
    );
  };

  const SelectColor = (props) => {
    const { field, name } = props;
    return (
      <>
        <>
          <Text size="sm">{name}</Text>
          <Center>
            <ColorInput
              dropdownZIndex={2500}
              value={field.value ?? ""}
              onChange={field.onChange}
            />
          </Center>
        </>
      </>
    );
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">확인</Button>
      </Center>
    );
  };

  const fields = [
    {
      key: "imgye_range",
      name: "임계치 범위",
      type: "etc",
      component: ThresholdRange,
      defaultValue: [
        defaultValue?.imgye_st ?? "",
        defaultValue?.imgye_ed ?? "",
      ],
    },
    {
      key: "img_url",
      name: "라이브러리",
      type: "etc",
      component: SelectLibrary,
    },
    {
      key: "t_cont",
      name: "대체 텍스트",
      type: "text",
    },

    {
      key: "t_font_s",
      name: "폰트 크기",
      type: "etc",
      component: SelectFontSize,
      defaultValue: 12,
    },
    {
      key: "t_font_c",
      name: "폰트 색상",
      type: "etc",
      component: SelectColor,
      defaultValue: "#000000",
    },
    {
      key: "t_cont_bg",
      name: "폰트 배경색",
      type: "etc",
      component: SelectColor,
      defaultValue: "#ffffff",
    },
    {
      key: "alarm_lvl",
      name: "알람 레벨",
      type: "text",
    },
    {
      key: "sms_cnt",
      name: "SMS 전송시도 최대수",
      type: "text",
    },
    {
      key: "sms_wait",
      name: "SMS 전송대기시간",
      type: "text",
    },
    {
      key: "sms_rewait",
      name: "SMS 재전송대기시간",
      type: "text",
    },
  ];

  return (
    <ObjectAddEditForm
      fields={fields}
      onSubmit={thresholdOnSubmit}
      submitButton={<SubmitButton />}
      defaultValues={defaultValue}
    />
  );
}

export default ThresholdForm;
